module.exports = __webpack_public_path__ + "img/carro1.ac742558.jpg";